module.exports = __webpack_public_path__ + "static/img/login_left.b6bb2261.svg";